<template>
  <div class="signin-layout">
    <div class="image-wrap">
      <div class="blue-bg" />
      <div
        class="image"
        :style="{backgroundImage:'url(' + image + ')'}"
      />
    </div>
    <LlLogo />
    <div
      v-if="signin"
      class="signin-card-wrap"
      :class="{firstSignin:firstSignin}"
    >
      <slot />
    </div>
    <div
      v-if="download"
      class="download-card-wrap"
    >
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: "SigninLayout",
  props: {
    signin: {
      type: Boolean,
      default: false,
    },
    download: {
      type: Boolean,
      default: false,
    },
    firstSignin: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    image: require("@/assets/image/Web-Login.jpg"),
  }),
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/signin-layout";
</style>